import { createContext, useContext } from 'react'

/**
 * When true the 3D viewer is in degraded "static" mode: the device dropped
 * below an acceptable frame rate, so camera rotation and door/drawer
 * interactions are disabled and the scene renders as a single still frame.
 * Applies to any device (mobile or desktop) that can't keep up.
 *
 * Provided by FurnitureViewer and consumed by the interactive column parts
 * (WardrobeColumn, RackColumn, Column) and by OrbitControls.
 */
export const StaticModeContext = createContext(false)

export function useStaticMode(): boolean {
  return useContext(StaticModeContext)
}